import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Was ein unbekannter Weg INNERHALB der Anwendung zeigt.
 *
 * Nicht zu verwechseln mit dem JSON-404 der API: unter `/api/…` ist ein
 * unbekannter Pfad ein Fehler fuer eine Maschine, hier ist er ein Tippfehler
 * eines Menschen. Zwei Adressaten, zwei Antworten (app/main.py).
 */
export function NichtGefunden() {
  const { t } = useTranslation()

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center gap-4 px-6 py-16">
      <h1 className="text-3xl">{t('rahmen.nicht_gefunden.titel')}</h1>
      <p className="text-text-muted">{t('rahmen.nicht_gefunden.text')}</p>
      <p>
        <Link
          className="font-semibold text-accent underline underline-offset-4 hover:text-accent-hover"
          to="/"
        >
          {t('rahmen.nicht_gefunden.zurueck')}
        </Link>
      </p>
    </main>
  )
}
